import produce from "immer";
import { create } from "zustand";
import * as api from "../services/article_import";

export const useArticleImportStore = create((set) => ({
  status: null,
  triggering: false,

  fetchStatus: async () => {
    const { data, error } = await api.getArticleImportStatus();
    if (data) {
      set(
        produce((draft) => {
          draft.status = data;
        }),
      );
    }
    return { data, error };
  },

  trigger: async ({ updateExisting = false } = {}) => {
    set(
      produce((draft) => {
        draft.triggering = true;
      }),
    );
    try {
      const { data, error, status } = await api.triggerArticleImport({
        updateExisting,
      });
      return { data, error, status };
    } finally {
      set(
        produce((draft) => {
          draft.triggering = false;
        }),
      );
    }
  },
}));
